<template>
  <div class="PaymentRecord">
    <el-row>
      <el-form :inline="true" :model="quertForm" class="demo-form-inline toolbar" style="padding-bottom:0px" @submit.native.prevent>
        <el-form-item label="老人姓名">
          <el-autocomplete v-model.trim="quertForm.oldName" auto-complete="off" placeholder="搜索老人姓名"
            :fetch-suggestions="querySearchAsync" @select="handleOlderSelect" style="width:130px">
          </el-autocomplete>
        </el-form-item>
        <el-form-item label="费用类型">
          <el-input v-model.trim="quertForm.name" auto-complete="off" placeholder="输入费用类型" style="width:120px"></el-input>
        </el-form-item>
        <el-form-item label="是否销账">
          <el-select v-model="quertForm.isRecharge" clearable placeholder="是否销账" style="width:120px" filterable>
            <el-option label="未销账" value="0"></el-option>
            <el-option label="已销账" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="扣费方式">
          <el-select v-model="quertForm.type" clearable placeholder="选择扣费方式" style="width:130px" filterable>
            <el-option label="每日扣费" value="0"></el-option>
            <el-option label="月度扣费" value="1"></el-option>
            <el-option label="按次扣费" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="时间范围">
          <el-date-picker v-model="quertForm.timevalue" unlink-panels type="daterange" start-placeholder="开始日期"
            end-placeholder="结束日期" style="width:220px" value-format="yyyy-MM-dd" clearable></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" plain @click="queryTable">查询</el-button>
          <el-button type="warning" icon="el-icon-plus" plain @click="oldConsumption">添加扣费</el-button>
          <el-button type="danger" icon="el-icon-check" plain @click="batchSettle" :disabled="selectedIds.length === 0">批量销账</el-button>
        </el-form-item>
      </el-form>
    </el-row>

    <el-row>
      <el-table
        :data="mergedData"
        :header-cell-style="{'text-align':'center','font-size':'16px','font-weight':'600',color:'#2d2d2d','background-color':'#d4f5fa'}"
        :cell-style="{'text-align':'center','font-size':'16px'}"
        :row-style="tableRowStyle"
        style="width:100%"
        @selection-change="handleSelectionChange"
        ref="multipleTable"
      >
        <el-table-column type="selection" width="45" :selectable="canSelectRow"></el-table-column>
        <el-table-column prop="_source" label="来源" min-width="90" align="center"></el-table-column>
        <el-table-column prop="_oldName" label="老人姓名" min-width="90" align="center"></el-table-column>
        <el-table-column prop="oldIdCard" label="身份证号" min-width="160" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="_projectName" label="项目名称" min-width="120" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column label="金额(元)" min-width="90" align="center">
          <template slot-scope="scope">{{ Number(scope.row._amount || 0).toFixed(2) }}</template>
        </el-table-column>
        <el-table-column prop="_time" label="时间" min-width="160" align="center"></el-table-column>
        <el-table-column prop="remark" label="备注" min-width="100" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column label="销账状态" min-width="90" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row._type==='deduct'">{{ formatRecharge(scope.row) }}</span>
            <span v-else></span>
          </template>
        </el-table-column>
        <el-table-column label="操作" min-width="140" align="center">
          <template slot-scope="scope">
            <template v-if="scope.row._type==='deduct'">
              <el-button type="primary" v-if="scope.row.status!=1" plain size="mini" @click="handleEdit(scope.row)">销账</el-button>
              <el-button type="danger" plain size="mini" @click="handleDelete(scope.row)">删除</el-button>
            </template>
          </template>
        </el-table-column>
      </el-table>
    </el-row>

    <div style="text-align:right;padding:8px 16px;font-size:15px;font-weight:bold;background:#fff;">
      本页合计：{{ pageTotal }} 元
    </div>
    <el-pagination class="fenye" background layout="total,prev,pager,next"
      :total="total" :current-page.sync="pageNum"
      @current-change="changePage" align="center"></el-pagination>

    <el-dialog title="新增扣费" :visible.sync="dialogConsumptionVisible" :close-on-click-modal="false"
      :close-on-press-escape="false" width="420px">
      <el-form ref="form" :model="chargeForm">
        <el-form-item label="长者姓名" :label-width="formLabelWidth" prop="oldmanId">
          <el-autocomplete v-model.trim="chargeForm.oldName" auto-complete="off" placeholder="搜索老人姓名"
            :fetch-suggestions="querySearchAsync2" @select="handleOlderSelect2" style="width:240px">
          </el-autocomplete>
        </el-form-item>
        <el-form-item label="身份证号" :label-width="formLabelWidth">
          <p>{{ chargeForm.oldIdCard }}</p>
        </el-form-item>
        <el-form-item label="费用类型" :label-width="formLabelWidth">
          <el-input v-model="chargeForm.projectType" placeholder="请输入缴费类型" clearable style="width:240px"></el-input>
        </el-form-item>
        <el-form-item label="扣费项目" :label-width="formLabelWidth">
          <el-input v-model="chargeForm.projectName" placeholder="请输入缴费项目" clearable style="width:240px"></el-input>
        </el-form-item>
        <el-form-item label="扣费日期" :label-width="formLabelWidth" prop="chargeDay">
          <el-date-picker v-model="chargeForm.chargeDay" type="date" style="width:240px"
            value-format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker>
        </el-form-item>
        <el-form-item label="缴费金额" :label-width="formLabelWidth" prop="consumptionFee">
          <el-input v-model.trim="chargeForm.consumptionFee" placeholder="请输入缴费金额" @input="inputChange1" style="width:240px">
            <span slot="suffix">/ 元 </span>
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button @click="dialogConsumptionVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm" :loading="chargeLoading">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import util from "@/utils/util.js";
import { formatConsumptionChargeType } from "@/utils/consumptionChargeType";
export default {
  data() {
    return {
      tableData: [],
      nursingData: [],
      quertForm: { oldName: "", oldIdCard: "", type: null, isRecharge: "", statusList: [0, 1, 2] },
      dialogConsumptionVisible: false,
      formLabelWidth: "100px",
      chargeForm: {},
      chargeLoading: false,
      total: 0,
      pageNum: 1,
      pageSize: 10,
      checkBill: [],
      feeTree: [],
      feeItem: [],
      selectedIds: [],
      selectedRows: [],
      pageTotal: 0,
    };
  },
  computed: {
    mergedData() {
      const deduct = this.tableData.map(r => ({
        ...r,
        _type: "deduct",
        _source: "扣费记录",
        _oldName: r.oldName,
        _projectName: r.projectName,
        _amount: r.consumptionFee,
        _time: r.createdTime || "",
      }));
      const nursing = this.nursingData.map(r => ({
        ...r,
        _type: "nursing",
        _source: "护理计费",
        _oldName: r.oldmanName,
        _projectName: r.projectName,
        _amount: r.amount,
        _time: this.formatDateTime(r.billTime),
      }));
      return [...deduct, ...nursing];
    },
  },
  methods: {
    formatDateTime(val) {
      if (!val) return "";
      const d = new Date(val);
      if (isNaN(d.getTime())) return val;
      const pad = n => String(n).padStart(2, "0");
      return d.getFullYear() + "-" + pad(d.getMonth()+1) + "-" + pad(d.getDate()) + " " + pad(d.getHours()) + ":" + pad(d.getMinutes()) + ":" + pad(d.getSeconds());
    },
    formatRecharge(row) {
      if (row.status == 0) return "未销账";
      if (row.status == 1) return "已销账";
      return "未销账";
    },
    handleEdit(row) {
      this.$confirm("是否确认销账?", "确认销账", { confirmButtonText: "确定", cancelButtonText: "取消", center: "true", type: "warning", closeOnClickModal: false })
        .then(() => {
          this.$postJson("fmc/account/settleBatch", { recordIds: [row.id], status: 1, totalAmount: row.consumptionFee, operator: sessionStorage.getItem("uerName") })
            .then(res => {
              this.$message({ message: res.message, type: res.code == 200 ? "success" : "error" });
              this.refreshAll();
            });
        }).catch(() => { this.$message({ type: "info", message: "已取消" }); });
    },
    handleDelete(row) {
      this.$confirm("确认删除该消费记录？删除后将退回 " + row.consumptionFee + " 元至老人余额。", "确认删除", { confirmButtonText: "确定", cancelButtonText: "取消", center: "true", type: "warning", closeOnClickModal: false })
        .then(() => {
          this.$postJson("fmc/account/deleteConsumptionRecord", { id: row.id }).then(res => {
            if (res.code == 200) { this.$message({ message: "删除成功，余额已退回", type: "success" }); this.refreshAll(); }
            else { this.$message({ message: res.message, type: "error" }); }
          });
        }).catch(() => { this.$message({ type: "info", message: "已取消" }); });
    },
    batchSettle() {
      if (this.selectedIds.length === 0) { this.$message.warning("请先选择要销账的记录"); return; }
      const totalAmount = this.selectedRows.reduce((sum, row) => sum + Number(row.consumptionFee || 0), 0);
      this.$confirm("是否确认对选中的" + this.selectedIds.length + "条记录进行批量销账?", "批量销账确认", { confirmButtonText: "确定", cancelButtonText: "取消", center: "true", type: "warning", closeOnClickModal: false })
        .then(() => {
          this.$postJson("fmc/account/settleBatch", { recordIds: this.selectedIds, status: 1, totalAmount, operator: sessionStorage.getItem("uerName") })
            .then(res => {
              this.$message({ message: res.code == 200 ? "批量销账成功，共销账" + this.selectedIds.length + "条记录" : res.message, type: res.code == 200 ? "success" : "error" });
              this.refreshAll();
            });
        }).catch(() => { this.$message({ type: "info", message: "已取消批量销账" }); });
    },
    handleSelectionChange(val) { this.selectedRows = val; this.selectedIds = val.map(row => row.id); },
    canSelectRow(row) { return row._type === "deduct" && row.status !== 1; },
    getFeeTree() { this.$postForm("mdc/dict/queryDictSubListByDictCode/feeType", { dictCode: "feeType" }).then(res => { this.feeTree = res.result; }); },
    querySearchAsync2(queryString, cb) {
      this.$postJson("omc/Oldman/quickShowAllOldMan", { oldName: queryString }).then(res => {
        if (res.result.list.length > 0) { res.result.list.forEach(i => { i.value = i.oldName; }); cb(res.result.list); }
        else { cb([{ uuid: "-1", value: "" }]); }
      });
    },
    handleOlderSelect2(item) { this.chargeForm.oldmanId = item.oldmanId; this.chargeForm.oldIdCard = item.oldIdCard; console.log(this.chargeForm); },
    inputChange1(val) { this.chargeForm.consumptionFee = val.replace(/[^0-9.]/g, "").replace(/^\D*(\d*(?:.\d{0,2})?).*$/g, "$1"); },
    oldConsumption() {
      this.dialogConsumptionVisible = true;
      this.chargeForm = { oldmanId: "", consumptionFee: "", projectType: "", projectName: "", chargeDay: util.formatDate.format(new Date(), "yyyy-MM-dd") };
    },
    submitForm() {
      if (!this.chargeForm.oldmanId) { this.$message.warning("请选择长者姓名"); return; }
      if (!this.chargeForm.consumptionFee) { this.$message.warning("请输入缴费金额"); return; }
      if (!this.chargeForm.projectType) { this.$message.warning("请输入费用类型"); return; }
      if (!this.chargeForm.projectName) { this.$message.warning("请输入扣费项目"); return; }
      this.chargeLoading = true;
      this.$postJson("fmc/account/oldConsumption", { oldId: this.chargeForm.oldmanId, createdTime: this.chargeForm.chargeDay + " 00:00:00", consumptionFee: this.chargeForm.consumptionFee, projectType: this.chargeForm.projectType, projectName: this.chargeForm.projectName })
        .then(res => {
          this.chargeLoading = false;
          if (res.code == 200) { this.dialogConsumptionVisible = false; this.refreshAll(); this.$message({ message: "添加成功", type: "success" }); }
          else { this.$message({ message: res.message, type: "error" }); }
        });
    },
    querySearchAsync(queryString, cb) {
      this.$postJson("omc/Oldman/quickShowAllOldMan", { oldName: queryString }).then(res => {
        if (res.result.list.length > 0) { res.result.list.forEach(i => { i.value = i.oldName; }); cb(res.result.list); }
        else { cb([{ uuid: "-1", value: "" }]); }
      });
    },
    handleOlderSelect(item) { this.quertForm.oldmanId = item.oldmanId; this.quertForm.oldIdCard = item.oldIdCard; },
    tableRowStyle({ rowIndex }) { return rowIndex % 2 == 0 ? "background-color: #ffffff" : "background-color: #e4f5f8"; },
    formatType(row) { return formatConsumptionChargeType(row); },
    queryPayList() {
      if (!this.quertForm.oldName) this.quertForm.oldmanId = null;
      let param = { oldId: this.quertForm.oldmanId, type: this.quertForm.type, name: this.quertForm.name, status: this.quertForm.isRecharge, pageNum: this.pageNum, pageSize: this.pageSize };
      if (this.quertForm.timevalue && this.quertForm.timevalue.length == 2) { param.startDay = this.quertForm.timevalue[0]; param.endDay = this.quertForm.timevalue[1]; }
      this.$postJson("fmc/account/queryConsumptionList", param).then(res => {
        this.tableData = res.result.list;
        this.total = Number(res.result.total);
        this.pageTotal = this.tableData.reduce((sum, row) => sum + Number(row.consumptionFee || 0), 0).toFixed(2);
        this.selectedIds = []; this.selectedRows = [];
        if (this.$refs.multipleTable) this.$refs.multipleTable.clearSelection();
      });
    },
    queryNursingList() {
      this.$postJson("omc/nursingBill/queryListWithPage", { pageNum: 1, pageSize: 200 }).then(res => {
        if (res.code !== 200) return;
        const list = res.result.list || [];
        const names = [...new Set(list.map(r => r.oldmanName).filter(Boolean))];
        const idCardMap = {};
        Promise.all(names.map(name =>
          this.$postJson("omc/Oldman/quickShowAllOldMan", { oldName: name }).then(r => {
            if (r.result && r.result.list) {
              const hit = r.result.list.find(o => o.oldName === name);
              if (hit) idCardMap[name] = hit.oldIdCard;
            }
          })
        )).then(() => {
          this.nursingData = list.map(r => ({ ...r, oldIdCard: idCardMap[r.oldmanName] || "" }));
        });
      });
    },
    refreshAll() {
      this.queryPayList(); this.queryNursingList();
      this.selectedIds = []; this.selectedRows = [];
      if (this.$refs.multipleTable) this.$refs.multipleTable.clearSelection();
    },
    queryTable() { this.pageNum = 1; this.queryPayList(); },
    changePage(val) { this.pageNum = val; this.queryPayList(); },
  },
  mounted() { this.queryPayList(); this.queryNursingList(); },
};
</script>

<style lang="scss" scoped>
.curcor { font-size: 28px; color: rgb(1, 185, 237); cursor: pointer; }
.are { color: #369a52; }
.no { color: red; }
.fenye { margin: 0; padding: 30px 0; background: #fff; }
::v-deep .el-table-column--selection .el-checkbox__inner { width: 16px; height: 16px; }
::v-deep .el-table-column--selection .el-checkbox { margin-right: 0; }
</style>
